import { updateDoor as updateDoorWall , updateWindow as updateWindowWall, updateElectricityPoint as updateElectricityPointWall } from './wall';
export const ROOM_SHAPES = {
    RECTANGLE: 'rectangle',
    L_SHAPE: 'l-shape',
    U_SHAPE: 'u-shape'
};

export function Room(name, lable, walls, requiredElectricity = []) {
    return {
        id: `room-${Date.now()}`,
        name,
        walls,
        lable,
        requiredElectricity
    };
}

export function updateWall(room, updatedWall) {
    return { ...room, walls: room.walls.map(wall => wall.id === updatedWall.id ? updatedWall : wall) };
}
export function updateDoor(room, updatedDoor) {
    const updatedWalls = room.walls.map(wall => {
        const matchingDoor = wall.doors?.find(door => door.id === updatedDoor.id);
        if (matchingDoor) {
            return updateDoorWall(wall, updatedDoor);
        }
        return wall;
    });
    return { ...room, walls: updatedWalls };
}

export function updateWindow(room, updatedWindow) {
    const updatedWalls = room.walls.map(wall => wall.id === updatedWindow.wallId ? updateWindowWall(wall, updatedWindow) : wall);
    return { ...room, walls: updatedWalls };
}

export function updateElectricityPoint(room, updatedElectricityPoint) {
    const updatedWalls = room.walls.map(wall => {
        const matchingElectricityPoint = wall.electricityPoints?.find(point => point.id === updatedElectricityPoint.id);
        if (matchingElectricityPoint) {
            return updateElectricityPointWall(wall, updatedElectricityPoint);
        }
        return wall;
    });
    return { ...room, walls: updatedWalls };
}

export function isElectricityValid(room) {
    const requiredElectricity = room.requiredElectricity || [];
    const currentPoints = room.walls?.flatMap(w => w.electricityPoints || []) || [];

    // Count required types (allowing duplicates)
    const requiredCounts = {};
    requiredElectricity.forEach(type => {
        requiredCounts[type] = (requiredCounts[type] || 0) + 1;
    });

    // Count actual types
    const actualCounts = {};
    currentPoints.forEach(point => {
        const type = point.type;
        actualCounts[type] = (actualCounts[type] || 0) + 1;
    });

    // Check that each required type has at least the required count
    return Object.entries(requiredCounts).every(([type, requiredCount]) => {
        const actualCount = actualCounts[type] || 0;
        return actualCount >= requiredCount;
    });
}

export function calculateRoomArea(walls) {
    if (walls.length < 3) return 0;

    let area = 0;
    for (let i = 0; i < walls.length; i++) {
        const j = (i + 1) % walls.length;
        area += walls[i].startPoint.x * walls[j].startPoint.y;
        area -= walls[j].startPoint.x * walls[i].startPoint.y;
    }
    return Math.abs(area / 2);
}

export function computeRoomCentroid(walls) {
    const points = walls.flatMap(w => [w.startPoint, w.endPoint]);
    const x = points.reduce((s, p) => s + p.x, 0) / points.length;
    const y = points.reduce((s, p) => s + p.y, 0) / points.length;
    return { x, y };
}

export function computePointsFromWalls(walls) {
    if (!walls || walls.length === 0) {
        return {
            minX: 0,
            maxX: 0,
            minY: 0,
            maxY: 0,
            centerX: 0,
            centerY: 0
        };
    }

    const xs = [];
    const ys = [];

    for (const w of walls) {
        xs.push(w.startPoint.x, w.endPoint.x);
        ys.push(w.startPoint.y, w.endPoint.y);
    }

    const minX = Math.min(...xs);
    const maxX = Math.max(...xs);
    const minY = Math.min(...ys);
    const maxY = Math.max(...ys);

    return {
        minX,
        maxX,
        minY,
        maxY,
        centerX: (minX + maxX) / 2,
        centerY: (minY + maxY) / 2
    };
}
function calculateRoomBoundingBox(walls) {
    const allX = walls.flatMap((w) => [w.startPoint.x, w.endPoint.x]);
    const allY = walls.flatMap((w) => [w.startPoint.y, w.endPoint.y]);
    const minX = Math.min(...allX);
    const maxX = Math.max(...allX);
    const minY = Math.min(...allY);
    const maxY = Math.max(...allY);

    const padding = 0.05; // 5cm extra hit padding
    const pts = [
        minX - padding, minY - padding,
        maxX + padding, minY - padding,
        maxX + padding, maxY + padding,
        minX - padding, maxY + padding
    ];
    return pts;
}

export function deriveRoomGeometry(walls) {
    const centroid = computeRoomCentroid(walls);
    const area = calculateRoomArea(walls);
    const boundingBox = calculateRoomBoundingBox(walls);
    return { centerX: centroid.x, centerY: centroid.y, area, boundingBox };
}


export function moveRoom(room, position) {
    const { dx, dy } = position;
    const updatedWalls = room.walls.map(wall => {
        return {
            ...wall,
            startPoint: {
                x: wall.startPoint.x + dx,
                y: wall.startPoint.y + dy
            },
            endPoint: {
                x: wall.endPoint.x + dx,
                y: wall.endPoint.y + dy
            }
        }
    });
    return {
        ...room,
        walls: updatedWalls
    };
}